export const Quiz = {
  '题目题干要求': 'Question Stem',
  '正确答案': 'Reference Answer',
  '答案公布时间': 'Answer Publish Time',
  '多模态知识卡': 'Knowledge Card',
  '答题设置': 'Quiz Settings',
  '分值设置': 'Score Settings',
  '满分值': 'Full Score',
  '直接回答': 'Direct Answer',
  '提示回答': 'Hint Answer',
  '公布后参与': 'Participate After Publish',
  '分': 'pts',
  '题目': 'Question',
  '点击知识卡可学习相关知识点': 'Click knowledge cards to learn related knowledge',
  '请选择答题方式': 'Please select your answering method',
  '选择后不可更改请谨慎选择': 'Cannot be changed after selection, please choose carefully',
  '由自己独立完成作答': 'Answer independently on your own',
  'AI将提供引导式指导帮助作答': 'AI will provide guided hints to help you answer',
  '最高可得': 'Max score: ',
  '满分': 'Full Score',
  '满分的': '',
  '答案将于': 'Answer will be published at ',
  '公布': '',
  '公布答案后参与最高可得': 'After publish, max score: ',
  '你选择了直接回答模式': 'You chose [Direct Answer] mode, ',
  '你选择了提示回答模式': 'You chose [Hint Answer] mode, ',
  '我的回答': 'My Answer',
  '请输入你的回答': 'Enter your answer...',
  '上传附件': 'Upload Attachment',
  '确认提交': 'Submit',
  'AI学习助手': 'AI Learning Assistant',
  '正在加载AI助手': 'Loading AI assistant...',
  '待评分': 'Pending Score',
  '参考答案': 'Reference Answer',
  '相关知识卡': 'Related Knowledge Cards',
  '点击查看': 'Click to view',
  '操作失败': 'Operation failed',
  '提交后不可修改确认提交': 'Cannot be modified after submission. Confirm submit?',
  '提交失败': 'Submission failed',
  '答题统计': 'Quiz Statistics',
  '已答题': 'Answered',
  '未答题': 'Not Answered',
  '已评分': 'Scored',
  '平均分': 'Avg Score',
  '最高分': 'Highest',
  '最低分': 'Lowest',
  '答题方式分布': 'Answer Mode Distribution',
  '人': ' students',
  '答题型话题标签': 'Quiz Topic',
  '参考资料': 'Reference Materials',
  '参考资料说明': 'Auxiliary learning materials for students, supports knowledge cards and files',
  '暂无参考资料': 'No reference materials',
  '同学作答': 'Classmates\' Answers',
  '暂无其他同学提交': 'No other classmates have submitted yet',
  '上传失败': 'Upload failed',
  '学生作答详情': 'Student Answer Details',
  '刷新': 'Refresh',
  'AI引导智能体': 'AI Hint Agent',
  '确认转换': 'Confirm Convert',
  '答题模式说明': 'Quiz topic has 3 answering modes:',
  '请输入题目题干要求': 'Enter question stem...',
  '请输入正确答案': 'Enter reference answer...',
  '答案已公布参与最高可得': 'Answer published, max score: ',
  '公布后参与答题': 'Participate After Publish',
  'AI助手暂不可用请直接作答': 'AI assistant unavailable, please answer directly',
  '已选择': 'Selected: ',
  '你选择了公布后参与模式': 'You chose [Participate After Publish] mode, ',
  '暂无参考答案': 'No reference answer provided by teacher',
  '老师未提供参考答案提示': 'The answer publish time has arrived, but the teacher has not set a reference answer.',
  '确认选择答题方式': 'Confirm Answer Mode',
  '选择此方式后不可更改': 'Cannot be changed after selection. Confirm: ',
  '知识卡': 'Knowledge Card',
  '文件': 'File',
  '暂无题干内容': 'No question stem provided',
  '答案将于时间公布': 'Answer will be published at the set time',
  '加载中': 'Loading...',
  '提交成功': 'Submitted successfully',
  '选择模式成功': 'Answer mode selected successfully',
  '暂无作答': 'No answers yet',
  '姓名': 'Name',
  '学号': 'Student ID',
  '答题方式': 'Answer Mode',
  '得分': 'Score',
  '提交时间': 'Submitted At',
  '展开查看': 'Expand to view',
  '暂无附件': 'No attachments',
  '普通话题': 'Normal Topic',
  '答题型话题': 'Quiz Topic',
  '话题类型': 'Topic Type',
  '转为答题型话题': 'Convert to Quiz Topic',
  '转为普通话题': 'Convert to Normal Topic',
  '转为普通话题提示': 'The quiz configuration will be removed. Confirm converting to a normal topic?',
  '转换成功': 'Converted successfully',
  '转换提示': 'After conversion, this topic will include a quiz feature requiring student responses.',
  '原话题内容': 'Original Topic Content',
  '一键带入题干要求': 'Import as Question Stem',
  '带入题干覆盖确认': 'There is existing question content. Overwrite?',
  '已带入题干要求': 'Question stem imported',
  '暂无话题内容': 'No topic content',
  '题干附件': 'Question Attachments',
  '参考资料文件': 'Reference Files',
  '参考答案附件': 'Reference Answer Attachments',
  '答案公布时间不设置': 'Not set (viewable after answering)',
  '请选择AI引导智能体': 'Please select AI hint agent (required)',
  '选择智能体': 'Select Agent',
  '暂无可用智能体': 'No AI hint agents available',
  '添加参考资料': 'Add reference',
  '教学资料': 'Course materials',
  '选择知识卡片': 'Select knowledge card',
  '课程未绑定知识库': 'This course is not linked to a multimodal knowledge library',
  'AI引导智能体辅助说明': 'AI-guided answering requires an available agent. If the list is empty, add or apply for one first.',
  '搜索智能体': 'Search agents',
  '前往添加智能体': 'Go to add or apply',
  '无匹配智能体': 'No matching results',
  topicDetailHasBody: 'Body filled',
  topicDetailHasFiles: 'Has attachments',
}
